import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class TableService {

  constructor(private http: HttpService) { }

  getData(url: string, params: any, successHandler: Function, errorHandler: Function): void {
    return this.http.doGet(url, params, successHandler, errorHandler);
  }

  cancelLote(loteId: number, importType: string, successHandler: Function, errorHandler: Function) {
    return this.http.doDelete(`/importacao-${importType}/${loteId}`, successHandler, errorHandler);
  }
}
